<template>
  <div class="details-container">
    <div class="details-top-row">
      <div class="details-row">
        <div class="details-col">
          <div class="detail-head">Focal Length:</div>
          <div class="detail-value">
            {{ details.focalLength || 'N/A' }}
          </div>
        </div>
        <div class="details-col">
          <div class="detail-head">Transmission:</div>
          <div class="detail-value">
            {{ details.transmission || 'N/A' }}
          </div>
        </div>
      </div>
      <div class="details-row">
        <div class="details-col">
          <div class="detail-head">Manufacturer:</div>
          <div class="detail-value">
            {{ details.manufacturer || 'N/A' }}
          </div>
        </div>
        <div class="details-col">
          <div class="detail-head cliphead">Series:</div>
          <div class="value-box-w-tooltip">
            <div class="clipped-tooltip" v-if="details.series">
              {{ details.series }}
            </div>
            <div class="detail-value clip">
              {{ details.series || 'N/A' }}
            </div>
          </div>
        </div>
      </div>
      <div class="details-row">
        <div class="details-col">
          <div class="detail-head">Lens Type:</div>
          <div class="detail-value">
            {{ details.lensType || 'N/A' }}
          </div>
        </div>
        <div class="details-col">
          <div class="detail-head">Lens Format:</div>
          <div class="detail-value">
            {{ details.lensFormat || 'N/A' }}
          </div>
        </div>
      </div>
      <div class="details-row">
        <div class="details-col">
          <div class="detail-head">Image Circle:</div>
          <div class="detail-value">
            {{ details.imageCircle || 'N/A' }}
          </div>
        </div>
        <div class="details-col">
          <div class="detail-head">Aperture Range:</div>
          <div class="detail-value">
            {{ details.apertureRange || 'N/A' }}
          </div>
        </div>
      </div>
      <div class="details-row">
        <div class="details-col">
          <div class="detail-head">Distortion:</div>
          <div class="detail-value">
            {{ details.distortion || 'N/A' }}
          </div>
        </div>
        <div class="details-col">
          <div class="detail-head">Weight:</div>
          <div class="detail-value">
            {{ details.weight || 'N/A' }}
          </div>
        </div>
      </div>
      <div class="details-row">
        <div class="details-col">
          <div class="detail-head">Squeeze Factor:</div>
          <div class="detail-value">
            {{ details.squeezeFactor || 'N/A' }}
          </div>
        </div>
        <div class="details-col">
          <div class="detail-head">Mount:</div>
          <div class="detail-value">
            {{ details.mount || 'N/A' }}
          </div>
        </div>
      </div>
      <div class="details-row">
        <div class="details-col">
          <div class="detail-head">Year:</div>
          <div class="detail-value">
            {{ details.year || 'N/A' }}
          </div>
        </div>
        <div class="details-col">
          <div class="detail-head">Country of Origin:</div>
          <div class="detail-value">
            {{ details.countryOfOrigin || 'N/A' }}
          </div>
        </div>
      </div>
      <div class="details-row">
        <div class="details-col">
          <div class="detail-head">Close Focus:</div>
          <div class="detail-value">
            {{ details.closeFocus || 'N/A' }}
          </div>
        </div>
        <div class="details-col"></div>
      </div>
    </div>

    <div class="details-bottom-row">
      <div class="details-bottom-left">
        <div class="details-row">
          <div class="details-col">
            <div class="detail-head">Flare Type:</div>
            <div class="detail-value tag">
              {{ getLensPropOptionLabel('flareType', details.flareType) || 'N/A' }}
            </div>
          </div>
        </div>
        <div class="details-row">
          <div class="details-col">
            <div class="detail-head">Flare Color:</div>
            <div class="detail-value tag">
              {{ getLensPropOptionLabel('flareColor', details.flareColor) || 'N/A' }}
            </div>
          </div>
        </div>
        <div class="details-row">
          <div class="details-col">
            <div class="detail-head">Flare Intensity:</div>
            <div class="detail-value tag">
              {{ getLensPropOptionLabel('flareIntensity', details.flareIntensity) || 'N/A' }}
            </div>
          </div>
        </div>
        <div class="details-row">
          <div class="details-col">
            <div class="detail-head">Lens Era:</div>
            <div class="detail-value tag">
              {{ getLensPropOptionLabel('lensEra', details.lensEra) || 'N/A' }}
            </div>
          </div>
        </div>
      </div>
      <div class="details-bottom-right">
        <div class="films-row" v-if="details.notableFilms?.length > 0">
          <div class="films-head">Notable Films:</div>
          <div
            class="films-data-box"
            :ref="setNotableFilmsRef"
            :style="{ minHeight: notableFilmsMinHeight + 'px' }"
          >
            <div
              class="films-data detail-value"
              v-for="film in details.notableFilms"
              :key="film.link"
            >
              <a :href="film.link" target="_blank"
                >{{ film.name }} <img src="@/assets/img/link-icon.svg" alt=""
              /></a>
            </div>
          </div>
        </div>
        <div class="films-row" v-if="details.note?.length > 0">
          <div class="films-head">Notes:</div>
          <div class="films-data-box notes-data-box">
            <div class="notes-item" v-for="(note, index) in details.note" :key="note.title + index">
              <div class="films-data detail-value" v-if="isNoteUrl(note.description)">
                <a :href="note.description.trim()" target="_blank"
                  >{{ note.title }} <img src="@/assets/img/link-icon.svg" alt=""
                /></a>
              </div>
              <div class="value-box-w-tooltip note-text-box" v-else>
                <div class="clipped-tooltip" v-if="note.description">
                  {{ note.description }}
                </div>
                <div class="detail-value clip note-text">
                  {{ note.title || 'N/A' }} <img src="@/assets/img/link-icon.svg" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="showFocalLengthTable" class="focal-length-details">
      <div class="table-wrapper">
        <table class="custom-table">
          <thead>
            <tr>
              <th>Focal Length</th>
              <th>Max Aperture</th>
              <th>Close Focus</th>
              <th>Weight</th>
              <th>Length</th>
              <th>Image Circle</th>
              <th>Front Diameter</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                {{ details.focalLength || 'N/A' }}
              </td>
              <td>
                {{ details.apertureRange || 'N/A' }}
              </td>
              <td>
                {{ details.closeFocus || 'N/A' }}
              </td>
              <td>
                {{ details.weight || 'N/A' }}
              </td>
              <td>
                {{ details.length || 'N/A' }}
              </td>
              <td>
                {{ details.imageCircle || 'N/A' }}
              </td>
              <td>
                {{ details.frontDiameter || 'N/A' }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="flares-sample" v-if="sampleImages?.length > 0">
      <SampleImages :images="sampleImages" :lensName="details.name" />
    </div>
  </div>
</template>

<script setup>
import { getLensPropOptionLabel, notableFilmsHeights } from '@/utils/string'
import SampleImages from './SampleImages.vue'
import { defineProps, computed, onBeforeUnmount } from 'vue'

const props = defineProps({
  details: {
    type: Object,
    required: true
  },
  sampleImages: {
    type: Array,
    default: () => []
  },
  showFocalLengthTable: {
    type: Boolean,
    default: false
  },
  side: {
    type: String,
    default: ''
  }
})

// A note description is either a clickable URL or plain text shown in the tooltip
const isNoteUrl = description => /^https?:\/\/\S+$/i.test(description?.trim() ?? '')

// notableFilmsHeights is a module-level singleton (see the imported util) so
// a lens with fewer notable films still gets its "Notable Films" block
// stretched to match the taller side, keeping the "Notes" row that follows
// aligned horizontally between both comparison panels.
const notableFilmsMinHeight = computed(() =>
  Math.max(notableFilmsHeights.left, notableFilmsHeights.right)
)

let notableFilmsObserver = null
let notableFilmsFrame = null

const setNotableFilmsRef = el => {
  notableFilmsObserver?.disconnect()
  notableFilmsObserver = null

  if (el && props.side) {
    notableFilmsObserver = new ResizeObserver(() => {
      // Deferring to the next frame avoids the "ResizeObserver loop
      // completed with undelivered notifications" warning, which fires
      // when the callback (via minHeight) changes the size of the very
      // element being observed within the same notification cycle.
      cancelAnimationFrame(notableFilmsFrame)
      notableFilmsFrame = requestAnimationFrame(() => {
        notableFilmsHeights[props.side] = el.scrollHeight
      })
    })
    notableFilmsObserver.observe(el)
  }
}

onBeforeUnmount(() => {
  notableFilmsObserver?.disconnect()
  if (props.side) {
    notableFilmsHeights[props.side] = 0
  }
  cancelAnimationFrame(notableFilmsFrame)
})
</script>

<style scoped>
.note-text-box .clipped-tooltip {
  padding: 8px 10px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  font-size: 12px;
  line-height: 1.5;
  color: #e4e4e4;
}

.notes-data-box {
  max-width: 160px;
  display: flex;
  flex-direction: column;
}

.notes-item:not(:last-child) {
  margin-bottom: 5px;
}

.note-text-box {
  width: 100%;
  cursor: pointer;
}

.note-text-box .note-text img {
  width: 10px;
  margin-bottom: 2px;
}

.note-text-box .note-text {
  white-space: normal;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  overflow-wrap: break-word;
  word-break: break-word;
  width: 100%;
  max-width: 100%;
}

.notes-item .films-data {
  min-width: 0;
  width: 100%;
}

.notes-item .films-data a {
  cursor: pointer;
  white-space: normal;
  overflow-wrap: break-word;
  word-break: break-word;
}
</style>
